<template>
  <div class="control-row">
    <controller field-name="top" :value="values.top" @input="updateModelTop"></controller>
    <controller v-if="enableX" :field-name="leftOrRight" :value="currentValue" @input="updateModelLeftRight" @field-clicked="toggleLeftRight" />
  </div>
</template>

<script>
import Controller from './Controller.vue';

const SCREEN_SIZE = 432;

export default {
  name: 'XYAxisWidgetControllers',
  components: {
    Controller,
  },
  data() {
    return {
      leftOrRight: 'left',
    };
  },
  computed: {
    otherSide() {
      return this.leftOrRight === 'left' ? 'right' : 'left';
    },
    left() {
      return this.values.left;
    },
    right() {
      return SCREEN_SIZE - (this.values.left + this.values.width);
    },
    currentValue() {
      return this.leftOrRight === 'left' ? this.left : this.right;
    },
  },
  props: {
    values: {},
    enableX: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    updateModelLeftRight(field, value) {
      const left = field === 'left' ? value : (SCREEN_SIZE - (value + this.values.width));
      this.$emit('update', 'left', left);
    },
    updateModelTop(field, value) {
      this.$emit('update', field, value);
    },
    toggleLeftRight() {
      this.leftOrRight = this.otherSide;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.control-row {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  &:first-of-type {
    margin-top: 0;
  }
  align-items: center;
  &.text-row {
    margin-bottom: 15px;
  }
  div {
    &:not(:last-of-type) {
      margin-right: 10px;
    }
  }
}
</style>
